import {useDispatch} from "react-redux";
import {bindActionCreators} from "@reduxjs/toolkit";

import { actions as GeoZoneSliceActions } from './../store/reducers/geoZones';
import { actions as UnitSliceActions } from './../store/reducers/units';
import { actions as PixiSettingsActions } from './../store/reducers/map/settings/pixi';
import { actions as ExpensesChartActions } from './../store/reducers/dashboard/expenses';
import { allActionCreators } from "../store/reducers/action-creators";

export const useActions = () => {
    const dispatch = useDispatch();
    return bindActionCreators(allActionCreators, dispatch);
}

export const useGeoZoneSliceActions = () => {
    const dispatch = useDispatch();
    return bindActionCreators(GeoZoneSliceActions, dispatch);
}

export const useUnitSliceActions = () => {
    const dispatch = useDispatch();
    return bindActionCreators(UnitSliceActions, dispatch);
}

export const useExpensesChartActions = () => {
    const dispatch = useDispatch();
    return bindActionCreators(ExpensesChartActions, dispatch);
}

export const usePixiSettingsActions = () => {
    const dispatch = useDispatch();
    return bindActionCreators(PixiSettingsActions, dispatch);
}


// хук для вызова actions по названию, сразу, без диспатча. 
// В нем доступны все actions проекта от всех action creators.